import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import HeatshrinkEditor from './HeatshrinkEditor.jsx';
import {wirecareTheme, techflexTheme} from './themes/siteThemes';

/**
 * Get theme configuration based on site code.
 * Host apps can pass a full theme object directly to HeatshrinkEditor
 * instead of using siteCode.
 */
const getThemeForSiteCode = (siteCode) => {
  switch (siteCode) {
    case 'tf':
      return techflexTheme;
    case 'wc':
    default:
      return wirecareTheme;
  }
};

// Extract props from URL query params for iframe usage
const getEditorPropsFromUrl = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const siteCode = (queryParams.get('site') || 'wc').toLowerCase();
  return {
    uuid: queryParams.get('uuid') || '',
    siteCode,
    designId: queryParams.get('designId') || '',
    theme: getThemeForSiteCode(siteCode)
  };
};

// Default callbacks for iframe mode - use postMessage
const handleEditingChange = (isEditing) => {
  window.parent.postMessage({type: 'isEditing', value: isEditing}, '*');
};

const handleOrderSubmit = (orderData) => {
  window.parent.postMessage(orderData, '*');
};

export default function App() {
  const {uuid, siteCode, designId, theme} = getEditorPropsFromUrl();
  const displayApp = uuid.length > 0;

  return (
    <Router>
      <Routes>
        <Route path="/health_check" element={<h3>healthy</h3>} />
        {displayApp ? (
          <Route
            path="/*"
            element={
              <HeatshrinkEditor
                uuid={uuid}
                siteCode={siteCode}
                designId={designId}
                theme={theme}
                onEditingChange={handleEditingChange}
                onOrderSubmit={handleOrderSubmit}
              />
            }
          />
        ) : null}
      </Routes>
    </Router>
  );
}
